export const defaultConfig = {
  confirmButtonText: '注册/登录',
  cancelButtonText: '取消',
  title: '登录可使用完整功能',
  content: '您还未登录哦! 使用该功能需要您有相应权限, 请注册/登录平台账号, 以验证您是否有相应权限。'
}

export const USER_AGREEMENT =
  'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/661e2539d66f020062cee7b8/index.html?magicplatform=zz&needNewWebview=1'

export const PRIVACY_POLICY =
  'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/622036ffd70026005ffa00db/index.html?magicplatform=zz&needNewWebview=1'
